var exports = {
  "Sl": "xaf9ae18d--4eafe0--image",
  "VN": "xaf9ae18d--4eafe0--close",
  "Qs": "xaf9ae18d--4eafe0--content",
  "pq": "xaf9ae18d--4eafe0--info",
  "wm": "xaf9ae18d--4eafe0--logo",
  "Cv": "xaf9ae18d--4eafe0--copyright",
};

module.exports = exports;
